import React from 'react';
import { DropDownMenuItem } from '../DropDownMenuItem.js';
import { useSelector } from 'react-redux';
export const DateFilterTypePicker = (props) => {
    const lang = useSelector((s) => s.lang);
    const filter = props.filter;
    if (filter != null && filter.type !== 'gt' && filter.type !== 'lt') {
        throw new Error('Invalid filter');
    }
    const updateFilter = (type) => {
        props.setFilter({ ...filter, type: type });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropDownMenuItem, { label: lang.views.before, onClick: () => {
                updateFilter('lt');
                props.onCloseMenu();
            } }),
        React.createElement(DropDownMenuItem, { label: lang.views.after, onClick: () => {
                updateFilter('gt');
                props.onCloseMenu();
            } })));
};
export const NotImplementedFilterTypePicker = (props) => {
    return React.createElement(React.Fragment, null, "Not implemented");
};
export const InFilterTypePicker = (props) => {
    const lang = useSelector((s) => s.lang);
    const filter = props.filter;
    if (filter != null &&
        filter.type !== 'in' &&
        !(filter.type === 'not' && filter.filter?.type === 'in')) {
        throw new Error('InFilterTypePicker requires an in filter or a not filter with in filter inside');
    }
    const updateFilter = (notFilter) => {
        if (notFilter) {
            if (filter.type === 'in') {
                props.setFilter({
                    id: filter.id,
                    filterKey: filter.filterKey,
                    type: 'not',
                    filter: {
                        ...filter,
                    },
                });
            }
        }
        else {
            if (filter.type === 'not' && filter.filter?.type === 'in') {
                props.setFilter({
                    ...filter.filter,
                    id: filter.id,
                    filterKey: filter.filterKey,
                });
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropDownMenuItem, { label: lang.views.is, onClick: () => {
                updateFilter(false);
                props.onCloseMenu();
            } }),
        React.createElement(DropDownMenuItem, { label: lang.views.isNot, onClick: () => {
                updateFilter(true);
                props.onCloseMenu();
            } })));
};
export const PausedUpdatesFilterTypePicker = (props) => {
    const lang = useSelector((s) => s.lang);
    const filter = props.filter;
    if (filter != null &&
        filter.type !== 'and' &&
        !(filter.type === 'not' && filter.filter?.type === 'and')) {
        throw new Error('ComplexFilterTypePicker requires an and filter or a not filter with an and filter inside');
    }
    const updateFilter = (applyNotOperation) => {
        if (!filter) {
            return;
        }
        if (applyNotOperation) {
            if (filter.type === 'and') {
                props.setFilter({
                    id: filter.id,
                    filterKey: filter.filterKey,
                    type: 'not',
                    filter: {
                        type: 'and',
                        filters: filter.filters,
                    },
                });
            }
        }
        else {
            if (filter.type === 'not' &&
                filter.filter &&
                filter.filter.type === 'and') {
                props.setFilter({
                    ...filter.filter,
                    id: filter.id,
                    filterKey: filter.filterKey,
                });
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropDownMenuItem, { label: lang.views.is, onClick: () => {
                updateFilter(false);
                props.onCloseMenu();
            } }),
        React.createElement(DropDownMenuItem, { label: lang.views.isNot, onClick: () => {
                updateFilter(true);
                props.onCloseMenu();
            } })));
};
//# sourceMappingURL=FilterTypePickers.js.map